import { Clock, MapPin, Phone } from "lucide-react";
import { BRAND } from "@/data/products";

export const TopBar = () => {
  return (
    <div className="bg-[#2D4A3E] text-white text-[11px] sm:text-xs">
      <div className="container-wide flex flex-wrap items-center justify-between gap-y-1.5 py-2">
        <div className="flex flex-wrap items-center gap-x-5 gap-y-1.5">
          <span className="inline-flex items-center gap-1.5">
            <Clock className="h-3.5 w-3.5 text-[#BFA573]" strokeWidth={1.5} />
            <span>Atendimento <strong className="font-medium">24h</strong></span>
          </span>
          <span className="hidden sm:inline-flex items-center gap-1.5">
            <MapPin className="h-3.5 w-3.5 text-[#BFA573]" strokeWidth={1.5} />
            <span>Entrega em <strong className="font-medium">todos os cemitérios do RJ</strong></span>
          </span>
        </div>
        <a
          href={`tel:+${BRAND.phoneE164}`}
          data-testid="topbar-phone"
          className="inline-flex items-center gap-1.5 hover:text-[#BFA573] transition-colors"
        >
          <Phone className="h-3.5 w-3.5 text-[#BFA573]" strokeWidth={1.5} />
          <span><strong className="font-medium">{BRAND.phoneDisplay}</strong></span>
        </a>
      </div>
    </div>
  );
};
